export const POST_CREATION_BUTTON_LABEL = 'post-creation-button.label';
